import { loadStripe, type Stripe } from '@stripe/stripe-js';

// loadStripe injects Stripe.js from js.stripe.com (PCI SAQ A — never bundle it).
// Cache the promise per publishable key so we don't reload the script.
let promise: Promise<Stripe | null> | null = null;
let cachedKey: string | null = null;

export function getStripePromise(publishableKey: string): Promise<Stripe | null> {
  if (!promise || cachedKey !== publishableKey) {
    cachedKey = publishableKey;
    promise = loadStripe(publishableKey);
  }
  return promise;
}
